module.exports = __webpack_public_path__ + "img/checkmark-square-2.e37306d3.svg";